import keys from '@debbie/common/dist/cache/keys.js';
import { caseFilterhash, } from '@debbie/common/dist/insights/index.js';
import * as api from '../api/workflows.js';
import q from '../query.js';
export const workflowsEntity = `workflows`;
const workflowByIdKey = (id) => `workflows-${id}`;
export const useWorkflowById = (id) => q.query(workflowByIdKey(id), () => api.getById(id), keys.read.item(workflowsEntity, id));
const workflowsKey = 'workflows';
export const useWorkflows = (options) => q.query(workflowsKey, api.get, keys.read.collection(workflowsEntity), {
    enabled: options?.enabled,
});
const workflowTaskStatsKey = (workflowId, taskId, caseFilter) => `workflow-task-stats-${workflowId}-${taskId}-${caseFilterhash(caseFilter)}`;
export const useWorkflowTaskStats = (workflowId, taskId, caseFilter) => q.query(workflowTaskStatsKey(workflowId, taskId, caseFilter), () => api.getTaskStats(workflowId, taskId, caseFilter), keys.read.collection(workflowsEntity));
const workflowStats = (workflowId, caseFilter) => `workflow-stats-${workflowId}-${caseFilterhash(caseFilter)}`;
export const useWorkflowStats = (workflowId, caseFilter) => q.query(workflowStats(workflowId, caseFilter), () => api.getStats(workflowId, caseFilter), keys.read.collection(workflowsEntity));
//# sourceMappingURL=index.js.map